import "controllers"

Turbo.session.drive = false